import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaTrash, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { toast } from 'react-toastify';
import paymentService from '../services/paymentService';

const PaymentsPage = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);

  const fetchPayments = async () => {
    try {
      const data = await paymentService.getAll();
      setPayments(data);
    } catch (error) {
      toast.error('Ödemeler yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const toggleRow = (id) => setExpandedRow(expandedRow === id ? null : id);

  const handleDelete = async (id) => {
    if (window.confirm('Bu kaydı silmek istediğinize emin misiniz?')) {
      try {
        await paymentService.delete(id);
        toast.success('Kayıt silindi.');
        fetchPayments();
      } catch (error) {
        toast.error('Silme işlemi başarısız.');
      }
    }
  };

  const filteredPayments = payments.filter(p => 
    p.company_name?.toLocaleLowerCase('tr-TR').includes(searchTerm.toLocaleLowerCase('tr-TR'))
  );

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Tahsilat & Ödeme</h2>
        <Link to="/payments/new" className="btn btn-primary">
          <FaPlus className="me-2" /> Yeni İşlem
        </Link>
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Cari adı ile ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="table-responsive d-none d-md-block">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>Cari Hesap</th>
                  <th>İşlem Tipi</th>
                  <th>Tutar</th>
                  <th>Ödeme Yöntemi</th>
                  <th>Açıklama</th>
                  <th>İşlemi Yapan</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {filteredPayments.map((payment) => (
                  <tr key={payment.id}>
                    <td>{new Date(payment.payment_date).toLocaleDateString('tr-TR')}</td>
                    <td>{payment.company_name}</td>
                    <td>
                      <span className={`badge ${payment.payment_type === 'tahsilat' ? 'bg-success' : 'bg-danger'}`}>
                        {payment.payment_type === 'tahsilat' ? 'Tahsilat' : 'Ödeme'}
                      </span>
                    </td>
                    <td className="fw-bold">
                      {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(payment.amount)}
                    </td>
                    <td>
                      {payment.payment_method === 'nakit' ? 'Nakit' : `Banka (${payment.bank_name || '-'})`}
                    </td>
                    <td>{payment.description}</td>
                    <td className="small text-muted">{payment.created_by_name || '-'}</td>
                    <td>
                      <button onClick={() => handleDelete(payment.id)} className="btn btn-sm btn-outline-danger">
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredPayments.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center">Kayıtlı işlem bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobil Görünüm */}
          <div className="d-md-none">
            {filteredPayments.map((payment) => (
              <div className="card mb-3 shadow-sm" key={payment.id}>
                <div className="card-body" onClick={() => toggleRow(payment.id)} style={{ cursor: 'pointer' }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-0 fw-bold">{payment.company_name}</h6>
                      <span className={`badge ${payment.payment_type === 'tahsilat' ? 'bg-success' : 'bg-danger'}`}>
                        {payment.payment_type === 'tahsilat' ? 'Tahsilat' : 'Ödeme'}
                      </span>
                    </div>
                    <div className="text-end">
                      <div className="fw-bold">{new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(payment.amount)}</div>
                      <small className="text-muted">{expandedRow === payment.id ? <FaChevronUp /> : <FaChevronDown />}</small>
                    </div>
                  </div>

                  {expandedRow === payment.id && (
                    <div className="mt-3 border-top pt-3">
                      <p className="mb-1"><strong>Tarih:</strong> {new Date(payment.payment_date).toLocaleDateString('tr-TR')}</p>
                      <p className="mb-1"><strong>Yöntem:</strong> {payment.payment_method === 'nakit' ? 'Nakit' : `Banka (${payment.bank_name || '-'})`}</p>
                      {payment.description && <p className="mb-1"><strong>Açıklama:</strong> {payment.description}</p>}
                      
                      <div className="d-flex justify-content-end gap-2 mt-3">
                        <button onClick={(e) => { e.stopPropagation(); handleDelete(payment.id); }} className="btn btn-sm btn-outline-danger">
                          <FaTrash /> Sil
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsPage;